<div class="trigger sco-body-medium-regular" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <button
    type="button"
    class="trigger-button trigger-label"
    aria-haspopup="tree"
    [attr.aria-expanded]="isOpen()"
    (click)="toggleOpen()">
    @if (hasSelection()) {
      <span class="trigger-prefix">{{ 'CATEGORY_SEARCH.PREFIX' | translate }}</span>
      <span class="trigger-title">{{ contextTitle() }}</span>
    } @else {
      <span class="trigger-title">{{ 'CATEGORY_SEARCH.ALL_CATEGORIES' | translate }}</span>
    }
  </button>
  @if (hasSelection()) {
    <button
      scoIconButton
      type="button"
      size="extra-small"
      variant="trailing"
      icon="bi bi-x"
      (click)="clearSelection($event)"></button>
  }
  <button type="button" class="trigger-button trigger-chevron" tabindex="-1" aria-hidden="true" (click)="toggleOpen()">
    <i class="si" [class.si-chevron-down-small]="!isOpen()" [class.si-chevron-up-small]="isOpen()"></i>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="positions"
  (overlayOutsideClick)="onOutsideClick($event)"
  (overlayKeydown)="$event.key === 'Escape' && close()"
  (detach)="close()">
  <div class="panel" [style.max-height.px]="panelMaxHeight()">
    <div class="panel-header">
      <sco-search
        [value]="filterText()"
        [placeholder]="'CATEGORY_SEARCH.FILTER_PLACEHOLDER' | translate"
        (changeAction)="onFilterInput($any($event.target).value)"
        (clearSearchInput)="clearFilter()">
      </sco-search>
    </div>

    <div class="tree" role="tree">
      @if (!filterText().trim()) {
        <div
          class="row sco-body-medium-regular"
          role="treeitem"
          [class.row--selected]="!hasSelection()"
          [attr.aria-selected]="!hasSelection()"
          (click)="selectAll()">
          <span class="chevron-slot"></span>
          <span class="row-title">{{ 'CATEGORY_SEARCH.ALL_CATEGORIES' | translate }}</span>
        </div>
      }
      @for (row of rows(); track row.node.id) {
        <div
          class="row sco-body-medium-regular"
          role="treeitem"
          [class.row--selected]="isSelected(row.node)"
          [style.padding-left.rem]="0.5 + row.level * 1.5"
          [attr.aria-level]="row.level + 1"
          [attr.aria-selected]="isSelected(row.node)"
          [attr.aria-expanded]="row.hasChildren ? row.expanded : null"
          (click)="select(row.node)">
          <span class="chevron-slot">
            @if (row.hasChildren) {
              <button
                scoIconButton
                type="button"
                size="extra-small"
                variant="trailing"
                tabindex="-1"
                [icon]="row.expanded ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"
                (click)="toggleExpanded(row.node, $event)"></button>
            }
          </span>
          <span class="row-title">{{ row.node.title }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>
